import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useBreadcrumbsData } from '../../Layout/breadcrumbsContext/useBreadcrumbsData/useBreadcrumbsData'

import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useQuery, useMutation } from '@percent/utility'
import { AgentVerificationDetails } from './AgentVerificationDetails'
import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'

export function AgentVerificationDetailsContainer() {
  const { agentVerificationService, adminService } = useServices()
  const { id } = useRequiredParams()
  const { setPath } = useBreadcrumbsData()
  const location = useLocation()

  const { data, isPending, errorMessage, refetch } = useQuery(
    ['/agent-verifications', id],
    agentVerificationService.getAgentVerification,
    { id }
  )

  const { data: orgData, isLoading: isOrgLoading } = useQuery(
    ['/organisations', data?.organisationId],
    adminService.getOrganisation,
    { id: data?.organisationId },
    { enabled: !!data?.organisationId }
  )

  const [{ status: approveStatus, errorMessage: approveErrorMessage }, { apiFunc: approveEmail }] = useMutation(
    agentVerificationService.approveAgentVerificationEmail
  )

  useEffect(() => {
    setPath(location.state || `${data?.status}`)

    return () => setPath(undefined)
  }, [location, setPath, data])

  return (
    <AgentVerificationDetails
      orgData={orgData}
      data={data}
      isLoading={isPending || approveStatus === 'pending' || isOrgLoading}
      errorMessage={errorMessage || approveErrorMessage}
      refresh={refetch}
      approveEmail={approveEmail}
    />
  )
}
